import { getRequiredMessage } from '@monetize/types/common';
import { z } from 'zod';

export type IEventType = {
  description: string;
  key: string;
};
export interface IEventCategory {
  category: string;
  types: IEventType[];
}

export const IWebhookEventSchema = z.object({
  eventType: z.string(),
});

export type IWebhookEvent = z.infer<typeof IWebhookEventSchema>;

export const IWebhookEventSchemas = z.tuple(
  [IWebhookEventSchema],
  IWebhookEventSchema,
);

export interface IWebhookResSchema {
  createdTime: string;
  description: string;
  enabled: boolean;
  locked: boolean;
  secret: string;
  tenantId: string;
  updatedTime: string;
  url: string;
  webhookId: string;
  events: z.infer<typeof IWebhookEventSchemas>;
}

export const WebhookReqSchema = z.object({
  url: z
    .url()
    .nonempty(getRequiredMessage('URL'))
    .refine(
      (val) => {
        return /^https?:\/\//.test(val);
      },
      {
        error: 'URL should start with http:// or https://',
      },
    ),
  events: IWebhookEventSchemas,
  enabled: z.boolean().optional(),
  description: z.string().nonempty(getRequiredMessage('Description')),
});

export type IWebhookReqSchema = z.infer<typeof WebhookReqSchema>;
